export default __webpack_public_path__ + "static/media/favicon.65fdb1a1.png";